module.exports = "\n<br/>\n\n<br/>\n\n<br/>\n\n<br/>\n\n<br/>"


//////////////////
// WEBPACK FOOTER
// /Users/globant/site/src/app/components/services/services.component.html
// module id = ../../../../../src/app/components/services/services.component.html
// module chunks = main